import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'encodeURIComponent' })
export class CrewEncodeURIComponent implements PipeTransform {

    transform(value: string): string {
        return encodeURIComponent(value);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/crew-encodeURIComponent.pipe.ts